import { Outlet } from 'react-router-dom';

const LoanProposal = () => <Outlet />;

export default LoanProposal;
